import React, { useMemo } from "react";
import Select from "react-select";

const personelId = (personel) => personel?._id || personel?.id || "";

const personelName = (personel) =>
  personel?.fullName ||
  personel?.nameSurname ||
  `${personel?.name || ""} ${personel?.surname || ""}`.trim() ||
  personel?.username ||
  "";

const personelDepartment = (personel) =>
  personel?.departman || personel?.departmanName || personel?.departmentName || personel?.birim || "";

function DofPersonelSelect({ personelList = [], value, onChange, loading = false, disabled = false }) {
  const options = useMemo(
    () =>
      personelList
        .map((personel) => ({
          value: String(personelId(personel)),
          label: personelName(personel),
          email: String(personel?.email || "").trim().toLowerCase(),
          departman: personelDepartment(personel),
        }))
        .filter((option) => option.value && option.label),
    [personelList]
  );

  const selectedOption =
    options.find((option) => option.label === value) ||
    (value ? { value: `legacy:${value}`, label: value, email: "", departman: "" } : null);

  return (
    <Select
      classNamePrefix="dof-select"
      isClearable
      isLoading={loading}
      isDisabled={loading || disabled}
      placeholder={loading ? "Personel listesi yükleniyor..." : "Sorumlu personel seçin..."}
      noOptionsMessage={() => "Personel bulunamadı"}
      options={options}
      value={selectedOption}
      filterOption={(option, input) => {
        const query = String(input || "").toLocaleLowerCase("tr-TR");
        if (!query) return true;
        return [option.data.label, option.data.email, option.data.departman]
          .join(" ")
          .toLocaleLowerCase("tr-TR")
          .includes(query);
      }}
      formatOptionLabel={(option) => (
        <div className="dof-person-option">
          <strong>{option.label}</strong>
          <small>{[option.departman, option.email].filter(Boolean).join(" · ")}</small>
        </div>
      )}
      onChange={(option) => onChange(option?.label || "")}
    />
  );
}

export default DofPersonelSelect;
